import { useCallback, useEffect, useRef } from 'react'

import { analytics } from './analytics'
import type { AnyAnalyticsEvent } from './events'

export function useAnalytics(): { track: (event: AnyAnalyticsEvent) => void } {
  const track = useCallback((event: AnyAnalyticsEvent) => analytics.track(event), [])

  return { track }
}

/** Отправляет событие один раз при монтировании компонента */
export function useTrackOnMount(event: AnyAnalyticsEvent): void {
  const eventRef = useRef(event)
  eventRef.current = event

  useEffect(() => {
    analytics.track(eventRef.current)
    // Событие отправляется один раз, при монтировании — зависимости намеренно пустые
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
